import { render } from "./DynamicAppComponentElement.vue.js?vue&type=template&id=607b61e0&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppComponentElement.vue?vue&type=template&id=607b61e0&scoped=true"
import script from "./DynamicAppComponentElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppComponentElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppComponentElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppComponentElement.vue?vue&type=script&lang=js"

import "./DynamicAppComponentElement.vue.css?vue&type=style&index=0&id=607b61e0&scoped=true&lang=css!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppComponentElement.vue?vue&type=style&index=0&id=607b61e0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607b61e0"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppComponentElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "607b61e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('607b61e0', __exports__)) {
    api.reload('607b61e0', __exports__)
  }
  
  module.hot.accept("./DynamicAppComponentElement.vue.js?vue&type=template&id=607b61e0&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppComponentElement.vue?vue&type=template&id=607b61e0&scoped=true", () => {
    api.rerender('607b61e0', render)
  })

}


export default __exports__